// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"478":"035bcda5","593":"0650c81d","978":"daa31f51"}[chunkId] + ".chunk.js";
};